module.exports = {
  CloseProject: 'Close Project',
  RebuildProject: 'Rebuild Project',
  ProjectNo: 'Project No.',
  CustomerName: 'Customer Name',
  ProjectStatus: 'Status',
  ProjectName: 'Project Name',
  ProjectCycle: 'Project Cycle',
  ProjectManager: 'Project Manager',
  ProjectDepartment: 'Project Department',
  ProjectOffice: 'Project Office',
  ExpectIncome: 'Expect Income',
  ExpectCost: 'Expect Cost',
  ExpectExpense: 'Expect Expense',
  RealIncome: 'Real Income',
  RealCost: 'Real Cost',
  RealExpense: 'Real Expense',
  SettleCurrency: 'Settle Currency',
  Remarks: 'Remarks',
  ExpectTotalCost: 'Expect Total Cost',
  RealTotalCost: 'Real Total Cost',
  ExpectProfitTate: 'Expect Profit Tate',
  RealProfitTate: 'Real Profit Tate',
  ReceiveStatus: 'Receive Status',
  PayStatus: 'Pay Status',
  StartDate: 'Start Date',
  EndtDate: 'end Date'
}
